module.exports = __webpack_public_path__ + "static/media/bg-modal-autenticar.a7bf4e64.png";